module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Copyright © 2009 by Kimberly A. Tessmer")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('strong', [_vm._v("Tell Me What to Eat If I Have Celiac Disease")]), _c('br'), _vm._v("Edited by Diana Ghazzawi"), _c('br'), _vm._v("Typeset by Gina Talucci"), _c('br'), _vm._v("Cover design by Lucia Rossman, DigiDog Design"), _c('br'), _vm._v("Printed in the U.S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further information on books from Career Press.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The Career Press, Inc., 220 West Parkway, Unit 12"), _c('br'), _vm._v("Pompton Plains, NJ 07444"), _c('br'), _c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.careerpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.careerpress.com")]), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.newpagebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.newpagebooks.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Tessmer, Kimberly A.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("Tell me what to eat if I have celiac disease : nutrition you can live with / by Kimberly A. Tessmer.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("     p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("ISBN 978-1-60163-061-2")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("   1. Gluten-free diet. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("RM237.86.T474 2003")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("615.8′54--dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyr"
  }, [_vm._v("2008053975")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567a8fe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03.vue
// module id = 66
// module chunks = 0